import _ from 'lodash';
import renderThreats from './renderThreats';
import initTableTooltip from './tableTooltip';
import initTableShadows from './tableShadows';

const state = {
  viewType: 'table',
  sortBy: null,
  sortType: true,
  selectedFilters: {
    country: false,
    type: false,
    title: false,
  },
};

function checkClearSideFilters() {
  if (!state.selectedFilters.country
    && !state.selectedFilters.type
    && !state.selectedFilters.title) {
    $('.side-filters__clear').addClass('disabled');
  } else {
    $('.side-filters__clear').removeClass('disabled');
  }
}

function checkViewType() {
  if (localStorage.getItem('viewType') === 'card') {
    state.viewType = 'card';
    $('#table-view').addClass('inactive-static');
    $('#card-view').addClass('active-static');
    $('#card-btn').prop('checked', true);
  } else {
    state.viewType = 'table';
    $('#card-view').addClass('inactive-static');
    $('#table-view').addClass('active-static');
    $('#table-btn').prop('checked', true);
  }
}

function removeStaticActive() {
  $('#table-view').removeClass('inactive-static');
  $('#card-view').removeClass('active-static');
  $('#card-view').removeClass('inactive-static');
  $('#table-view').removeClass('active-static');
}

function setThreatShade() {
  if (state.viewType === 'card') {
    $('#threats').addClass('no-shaders');
  } else {
    $('#threats').removeClass('no-shaders');
  }
}

function setlistHeight() {
  const threatContainter = $('#threats');
  threatContainter.css('height', 'auto');
  if (state.viewType === 'table') {
    const tableListHeight = $('.table-view-wrapper')[0].offsetHeight + 16 + 80;
    threatContainter.css('height', tableListHeight);
  } else {
    const cardListHeight = $('.card-list')[0].offsetHeight + 16 + 80;
    threatContainter.css('height', cardListHeight);
  }
}

function recalcNum() {
  const list = $('.table-list .table-list__item').toArray();
  list.forEach((item, index) => {
    $(item).find('.table-item__num')[0].innerText = index + 1;
  });
}

function clearFilters() {
  $('#filters-btn').off('click');
  $('.side-filters__wrapper').off('click');
  $('.side-filters__close').off('click');
  $('input[name="switch"]').off('change');
  $('.filter-head').off('click');
  $('input[name="country"]').off('change');
  $('input[name="type"]').off('change');
  $('input[name="title"]').off('change');
  $('input[data-filter_search]').off('input change search select close');
  $('.side-filters__clear').off('click');
  $('.table-view-wrapper').off('touchmove scroll');
}

export default function initFilters() {
  clearFilters();

  checkViewType();
  setlistHeight();
  initTableTooltip();
  initTableShadows();

  $('#search').on('input change search select close', _.debounce(async () => {
    renderThreats();
  }, 500));

  $('#period').selectmenu({
    change: () => {
      renderThreats();
    },
  });

  $('.filters-period').removeClass('arrow-before');

  $('#filters-btn').on('click', () => {
    $('.side-filters__wrapper').addClass('active');
    $('body').addClass('modal-open');
  });

  $('.side-filters__wrapper').on('click', (e) => {
    if (e.target.classList.contains('side-filters__wrapper')) {
      $('.side-filters__wrapper').removeClass('active');
      $('body').removeClass('modal-open');
    }
  });

  $('.side-filters__close').on('click', () => {
    $('.side-filters__wrapper').removeClass('active');
    $('body').removeClass('modal-open');
  });

  $('input[name="switch"]').on('change', (e) => {
    $('.threats-view').removeClass('active');
    removeStaticActive();
    state.viewType = e.target.value;
    localStorage.setItem('viewType', state.viewType);
    $(`#${state.viewType}-view`).addClass('active');
    setThreatShade();
    setlistHeight();
  });

  $('.js-sort').on('click', (e) => {
    $('.js-sort').removeClass('desc-sort');
    $('.js-sort').removeClass('asc-sort');
    const selectedSort = e.currentTarget.dataset.sort;
    const list = $('.table-list');

    if (state.sortBy === selectedSort && state.sortType === 'desc') {
      const defaultSorted = _.orderBy(list.children(), (item) => +item.dataset.rank, 'asc');
      list.html(defaultSorted);
      initTableTooltip();
      initTableShadows();
      recalcNum();
      state.sortBy = null;
      state.sortType = null;
      return;
    }

    if (state.sortBy === selectedSort) {
      e.currentTarget.classList.add('desc-sort');
      state.sortType = 'desc';
    } else {
      e.currentTarget.classList.add('asc-sort');
      state.sortType = 'asc';
    }

    state.sortBy = selectedSort;

    const sortedList = _.orderBy(list.children(), (item) => {
      if (['rank', 'graph', 'count'].indexOf(selectedSort) >= 0) {
        return +item.dataset[selectedSort];
      } else {
        return item.dataset[selectedSort] ? item.dataset[selectedSort].toLowerCase() : item.dataset[selectedSort];
      }
    }, state.sortType);

    list.html(sortedList);
    initTableTooltip();
    initTableShadows();
    recalcNum();
  });

  $('.filter-head').on('click', function (e) {
    const filterBlock = $(this).parent();
    if (filterBlock.hasClass('opened')) {
      filterBlock.removeClass('opened');
    } else {
      filterBlock.addClass('opened');
    }
  });

  $('input[name="country"]').on('change', (e) => {
    if ($('input[name="country"]:checked').length) {
      state.selectedFilters.country = true;
    } else {
      state.selectedFilters.country = false;
    }

    checkClearSideFilters();
    renderThreats();
  });

  $('input[name="type"]').on('change', (e) => {
    if ($('input[name="type"]:checked').length) {
      state.selectedFilters.type = true;
      $('.side-filters__filter[data-type="title"]').addClass('disabled');
    } else {
      state.selectedFilters.type = false;
      $('.side-filters__filter[data-type="title"]').removeClass('disabled');
    }

    checkClearSideFilters();
    renderThreats();
  });

  $('input[name="title"]').on('change', (e) => {
    if ($('input[name="title"]:checked').length) {
      state.selectedFilters.title = true;
      $('.side-filters__filter[data-type="type"]').addClass('disabled');
    } else {
      state.selectedFilters.title = false;
      $('.side-filters__filter[data-type="type"]').removeClass('disabled');
    }

    checkClearSideFilters();
    renderThreats();
  });

  $('input[data-filter_search]').on('input change search select close', (e) => {
    const list = $(`.filter-body__list[data-filter_list="${e.target.dataset.filter_search}"]`);
    const listItems = list.find('li').toArray();
    const searchStr = e.target.value.trim().toLowerCase();
    let hiddenCount = 0;
    listItems.forEach((item) => {
      if (!item.innerText.toLowerCase().includes(searchStr)) {
        item.classList.add('hidden');
        hiddenCount += 1;
      } else {
        item.classList.remove('hidden');
      }
    });
    if (hiddenCount === listItems.length) {
      list.addClass('empty');
    } else {
      list.removeClass('empty');
    }
  });

  $('.side-filters__clear').on('click', () => {
    $('.side-filters input:checkbox').removeAttr('checked');
    $('.side-filters__filter').removeClass('disabled');
    $('input[data-filter_search]').val('').trigger('change');
    state.selectedFilters.country = false;
    state.selectedFilters.type = false;
    state.selectedFilters.title = false;
    checkClearSideFilters();
    renderThreats();
  });
}
